module.exports = __webpack_public_path__ + "static/media/buy3.f378a273.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/buy/buy3.png
// module id = 1093
// module chunks = 0